import React from 'react';
import * as lib from '~/dependencies';
import * as NuacomScreens from '~/screens';

export default function Routes(props) {
  const { match } = props;

  return (
    <>
      <lib.Route
        exact
        path={`${match.path}/`}
        render={() => <NuacomScreens.Phone {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/dialPad`}
        render={() => <NuacomScreens.DialPad {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/contacts`}
        render={() => <NuacomScreens.Contact {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/callDetails`}
        render={() => <NuacomScreens.CallDetails {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/contactDetails/:id`}
        render={() => <NuacomScreens.ContactDetails {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/config`}
        render={() => <NuacomScreens.Configuration {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/teams`}
        render={() => <NuacomScreens.Teams {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/displayCall`}
        render={() => <NuacomScreens.DisplayCall {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/addNewContact`}
        render={() => <NuacomScreens.NewContacts {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/conversations`}
        render={() => <NuacomScreens.Conversations {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/conversations/new`} // ConversationID is the chat itself
        render={() => <NuacomScreens.NewConversation {...props} />}
      />
      <lib.Route
        exact
        path={`${match.path}/conversations/:id/view`} // ConversationID is the chat itself
        render={() => <NuacomScreens.Messages {...props} />}
      />
    </>
  );
}

Routes.propTypes = {
  match: lib.PropTypes.instanceOf(Object).isRequired,
};
